import axios from './axiosInstance';

export const practicesList = async (params) => {
  const response = await axios.get("/club_api/practices", { params });
  return response.data.practices;
};

export const createPractice = async (practice) => {
  const response = await axios.post(`/club_api/practices`, { practice});
  return response.data;
};

export const getPractice = async (teamId) => {
  const response = await axios.get(`/club_api/practices/${teamId}`);
  return response.data;
};

export const removePractice = async (practiceId) => {
  const response = await axios.delete(`/club_api/practices/${practiceId}`);
  return response.data;
};

export const updatedPractice= async (id,practice) => {
  const response = await axios.put(`/club_api/practices/${id}`, {practice});
  return response.data; 
};

export const detachPractice = async (id) => {
  const response = await axios.get(`/club_api/practices/${id}/detach_practice`);
  return response.data;
};

export const createSchedules = async (data) => {
  // const axiosNoInterceptors = axios.create();
  const response = await axios.post(`/club_api/schedules`, data);
  return response.data;
};

export const detailsSchedule = async (id, teamId) => {
  const response = await axios.get(`/v1/club_api/schedules/${id}`, { params: { team_id: teamId } });
  return response.data;
};
